import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
} from "reactstrap";
import loginbg from "../../assets/images/loginbg.png";
import findagramLogo from "../../assets/images/logoFindagram.png";
import ApiClient from "../BaseUrl/ApiClient";
import "./CardDetails.css";
import { Link, useHistory, useLocation } from "react-router-dom";
import {
  useStripe,
  useElements,
  PaymentElement,
  Elements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

function StripePaymentForm({ clientSecret, planType }) {
  const [email, setEmail] = useState("");
  const [cardholder, setCardholder] = useState("");
  const [loading, setLoading] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  const history = useHistory();

  // Convert planType number to string for state
  const getPlanTypeString = (type) => {
    switch(type) {
      case 1: return "standard";
      case 2: return "sponsored";
      default: return "standard";
    }
  };

  const [plantype, setPlantype] = useState(getPlanTypeString(planType))

  useEffect(() => {
    async function fetchSubscriptionData() {
      try {
        const token = localStorage.getItem("accessToken");
        const response = await ApiClient(token).get("/business/payment/subscription");
        const { responseData } = response.data;
        const subscriptionInfo = responseData?.subscriptionInfo || {};

      
        const authUser = JSON.parse(localStorage.getItem("authUser"));
        setEmail(authUser?.email || "");

        // If cardholder name is not in the API response, fetch from Stripe
        if (subscriptionInfo.paymentCard?.stripePaymentMethodId) {
          try {
            const paymentMethodResponse = await ApiClient(token).get(
              `/business/payment/method/${subscriptionInfo.paymentCard.stripePaymentMethodId}`
            );
            setCardholder(paymentMethodResponse.data.billing_details?.name || "");
          } catch (error) {
            toast.error("Failed to fetch cardholder name");
          }
        }
      } catch (error) {
        // toast.error("Failed to fetch subscription data");
      }
    }

    fetchSubscriptionData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) {
      toast.error("Stripe not initialized");
      return;
    }
    setLoading(true);
    try {
      const { setupIntent, error } = await stripe.confirmSetup({
        elements,
        confirmParams: {},
        redirect: "if_required",
      });
      if (error) {
        toast.error(error.message);
        setLoading(false);
        return;
      }
      if (setupIntent?.status === "succeeded") {
        const authUser = JSON.parse(localStorage.getItem("authUser"));
          const planTypeValue =
          plantype === "standard"
            ? 1
            : plantype === "sponsored"
              ? 2
              : "free";
        const payload = {
          stripeCustomerId: authUser?.stripeCustomerId || "68779fe49b6750e94186ad19",
          stripePaymentMethodId: setupIntent.payment_method,
          planType: planTypeValue,
        };
        ApiClient()
          .put("/business/payment/card", payload)
          .then((response) => {
            const { responseData } = response.data;
            const { data, subscriptionInfo } = responseData;
            if (data && data.user.roleType !== 1) {
              throw new Error("Access denied. Only business users can log in.");
            }
            if (data) {
              localStorage.setItem("accessToken", data.accessToken);
              localStorage.setItem("refreshToken", data.refreshToken);

              
              const updatedUser = {
                ...data.user,
                subscriptionType: planTypeValue,
              };

              localStorage.setItem("authUser", JSON.stringify(data.user));
            }


            if (subscriptionInfo) {
              localStorage.setItem("subscriptionType", planTypeValue);
              localStorage.setItem("subscriptionStatus", subscriptionInfo.subscriptionStatus || "");
              localStorage.setItem("subscriptionExpiryDate", subscriptionInfo.subscriptionExpiryDate || "");
            }

            toast.success("Subscription updated successfully!");
            setTimeout(() => {
              history.push("/business-profile");
            }, 1500);
          })
          .catch((error) => {
            const messages =
              error?.response?.data?.responseMessage || ["Update failed"];
            messages.forEach((msg) => toast.error(msg));
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        toast.error("Setup failed. Please try again.");
        setLoading(false);
      }
    } catch (err) {
      toast.error("Unexpected error occurred.");
      setLoading(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>

      <Row className="mt-3">
        <Col md={12}>
          <Label>Cardholder name</Label>
          <Input
            type="text"
            value={cardholder}
            placeholder="Enter your name"
            onChange={(e) => setCardholder(e.target.value)}
          />
        </Col>
      </Row>

   <Row className="mt-4">
        <Col md={12}>
          <Label>Payment Plan</Label>

          <div className="d-flex gap-2 flex-wrap">
            <Button
              color={plantype === "standard" ? "secondary" : "outline-secondary"}
              onClick={() => setPlantype("standard")}
              className="rounded-pill px-3 py-1 fs-6"
            >
              Standard - $20/month
            </Button>

            <Button
              color={plantype === "sponsored" ? "secondary" : "outline-secondary"}
              onClick={() => setPlantype("sponsored")}
              className="rounded-pill px-3 py-1 fs-6"
            >
              Sponsored - $100/month
            </Button>

          </div>


        </Col>
      </Row>

      <Row className="mt-4">
        <Col md={12}>
          <Label>Payment Details</Label>
          <div className="card-input">
            <PaymentElement options={{ layout: "tabs" }} />
          </div>
        </Col>
      </Row>
      <Button
        type="submit"
        disabled={!stripe || loading}
        className="mt-4 signin-btn w-100"
      >
        {loading ? "Processing..." : "Update Subscription"}{" "}
        <i className="ms-2 fa-solid fa-arrow-right" />
      </Button>
    </Form>
  );
}

function UpgradeSubscription() {
  const [clientSecret, setClientSecret] = useState(null);
  const location = useLocation();
  
  // Get planType from URL parameters
  const urlParams = new URLSearchParams(location.search);
  const planType = parseInt(urlParams.get('planType')) || 1;

  useEffect(() => {
    async function fetchClientSecret() {
      try {
        const authUser = JSON.parse(localStorage.getItem("authUser"));
        const customerId = authUser?.stripeCustomerId || "68779fe49b6750e94186ad19";
        const token = localStorage.getItem("accessToken");
        const { data } = await ApiClient(token).post(
          "/business/payment/setupIntent",
          { stripeCustomerId: customerId }
        );
        setClientSecret(data.responseData.setupIntent.client_secret);
      } catch (error) {
        toast.error("Failed to initialize Stripe");
      }
    }
    fetchClientSecret();
  }, []);

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="auth-page-content custom-auth-page">
        <MetaTags>
          <title>Update Subscription | BiteSaver</title>
        </MetaTags>
        <div className="header-navbar">
          <div className="logo-col">
            <Link to="/" className="logo-link">
              <img src={findagramLogo} alt="Findagram" height="40" />
            </Link>
          </div>
        </div>
        <div className="header-line border-bottom"></div>
        <div
          className="background-section"
          style={{
            backgroundImage: `url(${loginbg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            minHeight: "calc(100vh - 100px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Container className="carddetail">
            <Col md={8} lg={6} xl={5} className="card-col">
              <Card className="mt-3 login-card">
                <CardBody className="card-body">
                  <h3 className="card-text text-center mb-3 text-dark">
                    Update Your Bitesaver Subscription
                  </h3>
                  {clientSecret ? (
                    <Elements stripe={stripePromise} options={{ clientSecret }}>
                      <StripePaymentForm clientSecret={clientSecret} planType={planType} />
                    </Elements>
                  ) : (
                    <div className="text-center">Loading payment form...</div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
}

export default UpgradeSubscription;